import { Button, Input } from "@devhop/ui";
import { useCallback, useMemo } from "react";
import { SimpleSelect } from "@/shared/ui/SimpleSelect";

const ALL_VALUE = "__all__";

const CONDITION_OPTIONS = [
  { value: ALL_VALUE, label: "ທຸກສະພາບ" },
  { value: "new", label: "ໃໝ່" },
  { value: "used", label: "ໃຊ້ແລ້ວ" },
  { value: "refurb", label: "Refurb" },
];

export type CatalogSkusFilterValues = {
  search?: string;
  condition?: string;
};

type CatalogSkusFilterProps = {
  search: string;
  condition: string | undefined;
  onFilterChange: (updates: Partial<CatalogSkusFilterValues>) => void;
};

function toSelectValue(v: string | undefined) {
  return v && v !== "" ? v : ALL_VALUE;
}
function fromSelectValue(v: string) {
  return v === ALL_VALUE ? undefined : v;
}

export function CatalogSkusFilter({
  search,
  condition,
  onFilterChange,
}: CatalogSkusFilterProps) {
  const value = toSelectValue(condition);
  const update = useCallback(
    (updates: Partial<CatalogSkusFilterValues>) => {
      onFilterChange(updates);
    },
    [onFilterChange],
  );

  const hasFilter =
    (search && search.trim() !== "") || (condition && condition !== ALL_VALUE);

  const options = useMemo(() => CONDITION_OPTIONS, []);

  return (
    <div className="mb-4 flex flex-wrap items-center gap-3 px-2">
      <Input
        placeholder="ຄົ້ນຫາຕາມ OEM Part No..."
        value={search ?? ""}
        onChange={(e) => update({ search: e.target.value || undefined })}
        className="h-8 w-48"
      />
      <SimpleSelect
        value={value}
        onValueChange={(v) => update({ condition: fromSelectValue(v) })}
        options={options}
        placeholder="ສະພາບ"
        className="h-8 w-36"
      />
      {hasFilter && (
        <Button
          variant="ghost"
          size="sm"
          onClick={() => update({ search: undefined, condition: undefined })}
        >
          ລ້າງຕົວກອງ
        </Button>
      )}
    </div>
  );
}
